import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2';
import React from 'react'
import { ReactFitty } from 'react-fitty'
import introImg from '../../assets/img/introductionPage/intro.jpg'

const Introduction = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100dvh',
        padding: '100px 100px 0 100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#e5e8d9',
        '@media screen and (max-width: 600px)': {
          padding: '100px 10px'
        }
      }} >
      <Typography
        sx={{ textAlign: 'center', position: 'relative', zIndex: 1, color: '#fd4002', lineHeight: 0.8 }}
        component={ReactFitty}
      >
        INTRODUCTION
      </Typography>
      <Typography
        color='secondary'
        sx={{
          fontFamily: "Great Vibes",
          textAlign: 'left',
          position: 'relative',
          zIndex: 2,
          width: '100%',
          marginTop: "-150px",
          fontSize: '9rem',
          padding: '0 30px',
          '@media screen and (max-width: 600px)': {
            fontSize: '4rem',
            textAlign: 'right',
            marginTop: "-90px",
          }
        }}>
        Intro
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12, lg: 12, xl: 4 }}>
          <Typography color='secondary' fontWeight={700} sx={{
            // '@media screen and (min-width: 901px)': {
            //   fontSize: '2rem'
            // }
          }}>
            Создание масштабируемых и производительных веб-приложений с акцентом на удобство, скорость и качество. Разработка на React, TypeScript, интеграция современных UI/UX решений и оптимизация производительности.
            Фокус на чистом коде, эффективных архитектурных решениях и внимании к деталям. Постоянное изучение новых технологий и поиск лучших практик для создания продуктов, которые работают.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12, xl: 8 }}>
          <Box width={"100%"} sx={{ borderRadius: "8px" }}>
            <img src={introImg} alt="intro" width={"100%"} style={{ borderRadius: "8px", maxHeight: "500px" }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Introduction